import { render, staticRenderFns } from "./PaginatedTableView.vue?vue&type=template&id=0cac8598&scoped=true&lang=pug&"
import script from "./PaginatedTableView.vue?vue&type=script&lang=js&"
export * from "./PaginatedTableView.vue?vue&type=script&lang=js&"
import style0 from "./PaginatedTableView.vue?vue&type=style&index=0&id=0cac8598&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cac8598",
  null
  
)

export default component.exports